import { useMemo } from 'react';
import { useHttpClient } from '@wix/cli-http-client-react';
import { usePanoramaMethodLogger } from '@wix/cli-panorama';
import { ExtensionDataClient } from './extension-data-client.js';

export function useExtensionDataClient() {
  const httpClient = useHttpClient({ type: 'backoffice' });
  const client = useMemo(
    () => new ExtensionDataClient(httpClient),
    [httpClient]
  );

  return usePanoramaMethodLogger(client);
}
